import { Injectable } from '@angular/core';
import { DataService } from '../common/data.service';
@Injectable({
  providedIn: 'root'
})
export class JournalVoucherService {

  // export class PayrollVoucherService {

  constructor(private _data: DataService) { }

  
  /*******************************Service Methods*************************************/
  // GenerateJournalVoucher = (data: any): any => {    
  //   return this._data.PostData('JournalVoucher/GenerateJournalVoucher', data);
  // }
  GenerateJournalVoucher = (data: any): any => {    
    return this._data.PostData('JournalVoucher/SendToPayrollForRecovery', data);
  }

  // SendToPayrollForRecovery = (data: any): any => {    
  //   return this._data.PostData('JournalVoucher/SendToPayrollForRecovery', data);
  // }

  GetAllEmployeeRecoveryList = (data: any): any => {
    return this._data.PostData('EmployeeRecovery/GetAllEmployeeRecoveryList', data);
  }
  GetAllEmployeeRecoveryFinanceJVList = (data: any): any => {
    return this._data.PostData('JournalVoucher/GetAllEmpFinanceJVList', data);
  }

  GetEmployeeRecoveryDataByID = (ID: string): any => {
    return this._data.GetDataById('EmployeeRecovery/GetEmployeeRecoveryByID', ID);
  }
  RecoveryExportData = (data: any): any => {
    return this._data.DownloadFileWithPost('EmployeeRecovery/ExportToExcel', data);
}
EmployeeRecoveryDetails = (data: any): any => {
  return this._data.PostData('EmployeeRecovery/EmployeeRecoveryWaveOffDetails', data);
}
UploadClientResponseData = (data: any): any => {
  return this._data.postfile('EmployeeRecovery/AttachmentModel', data);
}
GetEmployeeRecoveryWaveOffDetailsByID=(ID:string):any=>{
  return this._data.GetDataById('EmployeeRecovery/GetEmployeeRecoveryWaveOffByID', ID);
}

GetAttachment = (data: any): any => {
  return this._data.DownloadFileWithPost('EmployeeRecovery/ShowAttachFile', data);
}

  /**********************************END*********************************************/
}
